import {SubCardPriceWrapper} from "./listView.style";
import NumberFormat          from "react-number-format";
import Text                  from "reusecore/src/elements/Text";
import {CURRENCY}            from "../../Config";

const Price = ({amount}) => {

    return (
        process.browser && amount > 0 ? (
            <SubCardPriceWrapper>
                <NumberFormat
                    value={amount}
                    displayType={'text'}
                    thousandSeparator={' '}
                    renderText={value => (
                        <Text mb={0} content={`${value} ${CURRENCY} `} />
                    )}
                />
            </SubCardPriceWrapper>
        ) : ''
    )
}

export default Price;